export default "__VITE_ASSET__BdYiejVG__"